<template>
  <div class="modal-overlay" v-if="showLoginModal" @click.self="close">
    <div class="modal-content">
      <button class="close-btn" @click="close">&times;</button>

      <div class="modal-header">
        <h2><span class="sports">SPORTS</span><span class="hub">HUB</span></h2>
        <h3>Welcome to Sports Hub</h3>
        <p class="subtitle">The ultimate FREE sports platform for all the latest action and updates!</p>
      </div>

      <div class="modal-body">
        <label>Enter Your Cellphone Number</label>
        <input
          type="tel"
          v-model="phoneNumber"
          placeholder="Enter Your Cellphone Number"
          @keyup.enter="submit"
        />

        <button class="submit-btn" @click="submit" :disabled="isLoading">
          {{ isLoading ? 'Sending...' : 'SUBMIT' }}
        </button>

        <p class="terms text-center">
          By continuing you agree to the <a href="#">terms & conditions</a>.<br>
          Data charges may apply.
        </p>

        <p class="error text-center" v-if="error">{{ error }}</p>
        <div class="invalid-msisdn mt-2 text-center" v-if="isNotOnNetwork">
          Incorrect network provider!
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import DcbService from '../services/dcbService'
import UtilsService from '@/services/utilsService'
import modalMixin from '@/mixins/modalMixin'
import { getSubscriptionFromGetUser, ServiceIds } from '@/config'

const MIN_PHONE_LENGTH = 10

export default {
  name: 'LoginModal',
  mixins: [modalMixin],
  data() {
    return {
      phoneNumber: '',
      isNotOnNetwork: false
    }
  },
  computed: {
    ...mapState(['showLoginModal', 'isLoading', 'error', 'brandConfig'])
  },
  methods: {
    ...mapMutations([
      'closeAllModals', 'setIsLoading', 'setError', 'setMsisdn',
      'setOtpMessage', 'setShowLoginModal', 'setShowOtpModal',
      'setShowOffnetModal', 'setServiceId'
    ]),

    async checkNetworkStatus() {
      try {
        const response = await UtilsService.checkUserOnNet(this.phoneNumber)
        return response?.data?.isOnNet ?? response?.data?.onNet ?? response?.data ?? false
      } catch (error) {
        console.error('Network check failed:', error)
        return false
      }
    },

    async resolveServiceId() {
      const userResponse = await DcbService.getUserViaProductId(this.phoneNumber)
      if (userResponse.success) {
        const { serviceId } = getSubscriptionFromGetUser(userResponse)
        return serviceId
      }
      return ServiceIds.free
    },

    async requestOtp() {
      this.setIsLoading(true)
      this.isNotOnNetwork = false

      this.phoneNumber = DcbService.formatMsisdn(this.phoneNumber)

      const isCorrectNetwork = await this.checkNetworkStatus()
      if (!isCorrectNetwork) {
        this.isNotOnNetwork = true
        this.setIsLoading(false)
        return
      }

      const serviceId = await this.resolveServiceId()
      this.setServiceId(serviceId)

      const result = await DcbService.requestOtp(this.phoneNumber, serviceId)
      this.setIsLoading(false)

      if (result.success) {
        this.setMsisdn(this.phoneNumber)
        this.setOtpMessage(result.message)
        this.setShowLoginModal(false)
        this.setShowOtpModal(true)
      } else if (result.error === 'offnet') {
        this.setShowLoginModal(false)
        this.setShowOffnetModal(true)
      } else {
        this.setError(result.message)
      }
    },

    async submit() {
      if (this.phoneNumber.length < MIN_PHONE_LENGTH) return

      this.setIsLoading(true)
      this.setError(null)
      this.isNotOnNetwork = false

      await this.requestOtp()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/modal-common';

.subtitle {
  font-size: 14px;
  color: $gray-600;
  margin: 0;
}

.invalid-msisdn {
  font-size: 12px;
  color: $error;
  margin-top: $space-sm;
}
</style>
